export const TAB_BAR_COLOR = "#D0D0D0";
export const MAIN_WHITE = "#FFFFFF";
export const MAIN_BLACK = "#000000";
export const MAIN_RED = "#E51C24";
export const LINK_RED = "#ED1C24";
export const MAIN_GREEN = "#28A177"; // rgb(40, 161, 119)
export const OLIVINE = "#95BF6E"
export const MAIN_GRAY = "#817979"; //rgb(129,121,121)
export const MAIN_COOL_GRAY = "#EDEDED"; //rgb(237,237,237)
export const MAIN_ORANGE = "#FF8400"; // rgb(225, 132, 0)
export const SECONDARY_BLACK = "#333333"; // rgb(51,51,51);
export const SECONDARY_DISABLE_GRAY = "#EEEEEE"; //rgb(238, 238, 238)
export const SECONDARY_COOL_GRAY = "#E3E3E3"; //rgb(227, 227, 227)
export const SECONDARY_COOL_GRAY_2 = "#B3B3B3"; //rgb(179, 179, 179)
export const SECONDARY_COOL_GRAY_3 = "#D5D5D5"; // rgb(213, 213, 213)
export const SECONDARY_ORANGE = "#F39200";
export const SECONDARY_BLUE = "#218BD8";
export const SECONDARY_GREEN = "#87BA49";
export const SECONDARY_PURPLE = "#5955A1";
export const GRAY_98 = "#989898"; //rgb(152, 152, 152)
export const GRAY_NEW = "#BBBBBB";
export const DUSTY_GRAY = "#999999"
export const GRAY_OTHER = "#E2E3E4" // rgb(102, 102, 102)
export const MAIN_BLUE="#38ACDE"
export const MAIN_DARK_BLUE="#0F82B4"
export const DUSTY_RED='#fff4f3'
export const DUSTY_RED_DARK='#fcc8c2'
export const MERCHANTIDDELIVERY="8315f8c6-e86a-4089-b7e6-f4ef775dd2c7"